import React from "react";
import { Spin } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { UiLoading } from "./Loading.style";
/**
 * loading ~
 */

const Loading = () => {
  return /*#__PURE__*/React.createElement(UiLoading, null, /*#__PURE__*/React.createElement(Spin, {
    indicator: /*#__PURE__*/React.createElement(Loading3QuartersOutlined, {
      spin: true
    }),
    size: "large"
  }));
};

export default Loading;